import { useMakeStore } from '@/store/makes';

export const carsOptions = {
  getCarMakes: async (query = '') => {
    const store = useMakeStore();
    await store.fetchMakes({ 'filter[name]': query });
    return store.makes;
  }
};
